
import api from "@/api/index"; //ABP API接口
import { Vue, Component } from "vue-property-decorator";
import { ElementTableView } from "@/lib/ElementTableView";
import ElTableColumnCopy from "@/components/ElTableColumnCopy/index.vue";
import { MessageBox } from "element-ui";

import {OrganizationUnitDto, SwiperDto} from "@/api/appService";

import EditSwiper from "./components/edit-Swiper.vue";

@Component({
  name: "AdSwiperList",
  components: {
    EditSwiper,
    ElTableColumnCopy
  }
})
export default class SwiperList extends ElementTableView {
  tableItems: SwiperDto[] = [];
  currentOu:any;


  filter(v: number) {
    return "123";
  }

  get showCopyFrom(){
    const currentOu = this.$store.getters['user/ou'] as OrganizationUnitDto;
    return currentOu.level === '门店';
  }

  async created() {
    this.currentOu =  this.$store.getters['user/ou'] as OrganizationUnitDto;
    await this.fetchData();
  }

  // 获取表数据
  async fetchData() {
    this.table.listLoading = true;
    await api.swiper
      .getAll({
        keyword: this.queryForm.keyword,
        sorting: this.table.sorting,
        skipCount: this.skipCount,
        maxResultCount: this.table.pagesize
      })
      .then(res => {
        console.log(res);
        this.table.listLoading = false;
        this.tableItems = res.items!;
        this.table.totalCount = res.totalCount!;
      });
  }

  // 新建
  handleCreate() {
    (this.$refs.editForm as any).show = true;
  }



  // 编辑
  handleEdit(index: number, row: any) {
    (this.$refs.editForm as any).show = true;
    (this.$refs.editForm as any).form = row;

    console.warn("%cu must reWrite this method", "color:#0048BA;");
  }

  // 删除
  async handleDelete(index: number, row: SwiperDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.swiper
        .delete({
          id: row.id
        })
        .then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.fetchData();
        });
    });
  }

  async handleSync(row:SwiperDto){
    this.$confirm('您确认要同步吗','提示').then(async ()=>{
      await api.swiper.sync({body:{id:row.id}}).then(res=>{
        this.$message({type:'success',message:'同步完成!'});
      })
    });
    ;
  }

  // 更新当前页
  async current_change(e: number) {
    this.table.page = e;
    await this.fetchData();
  }

  // Table排序
  async sort(e: any) {
    console.log("sort : ", e);
    if (e.prop && e.order) {
      this.table.sorting = `${e.prop} ${e.order}`;
    }
    await this.fetchData();
  }

  // 修改一页显示的条目
  async handleSizeChange(e: number) {
    this.table.pagesize = e;
    await this.fetchData();
  }

  // 搜索
  async handleSearch() {
    await this.fetchData();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      keyword: "",
      from: undefined,
      to: undefined,
      isActive: undefined
    };
    await this.fetchData();
  }

  async handelOnSaved() {
    await this.fetchData();
  }
}
